import React from "react";
import { Button } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { Registry } from "react-registry";
import { generateSchema } from "decorator-form";
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { BoxView } from "common/views/box/Box.view";
import { ButtonView, ButtonVariant } from "common/views/button/Button.view";
import Label from "core/components/label/Label";
import TokenSession from "core/util/session/TokenSession";
import { CardVariant, CardView } from "common/views/card/Card.view";
import { CarouselView } from "common/views/carousel/Carousel.view";
import { DialogView } from "common/views/dialog/Dialog.view";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import { RowsView } from "common/views/rows/Rows.view";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { iDef } from "core/util/TypeUtils";
import labelProvider from './QuickLinks.labels';
import { ItemTypeOptions, ListTypeOptions, QuickLinksPanelConfig } from "./QuickLinksConfig";
import Class from "core/util/Class";
import PanelConfigForm from "core/components/editor/panels/PanelConfigForm";

const { Labels } = labelProvider;
export interface QuickLinksFormState {
	isOpen: boolean; // for dialog edit view
	toggleOpen: boolean;
}
@Panel({id: "quick-links", configClass: QuickLinksPanelConfig, labelProvider})
export default class QuickLinksPanel extends React.PureComponent<IPanelProps<QuickLinksPanelConfig>, QuickLinksFormState> {

	public state: QuickLinksFormState = {
		isOpen: false,
		toggleOpen: false,
	};
	private toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });
	private onSubmit = () => this.setState({ isOpen: !this.state.isOpen }, this.props.actions.saveAdminConfig);
	private showDialog = () => {
			const id = 'quick-links';
			const clazz = Registry.get({id, registry: "panels:config"}) as Class<any>;
			const schema = clazz ? generateSchema(clazz) : null
			
			const properties = Object.keys(schema.schema.properties); // to remove layout properties from dialog for admin
			properties.forEach((property)=>{
				if(property !== 'content') {
					delete schema.schema.properties[property];
				}
			})
			return (
				<DialogView
					isOpen={this.state.isOpen}
					onClose={this.toggleOpen}
					viewKey="dialog"
				>
					<BlockView viewKey="card-primary">
						<PanelConfigForm instance={this.props.instance} schema={schema}/>
						<ButtonView viewKey="entityForm.submit" variant={ButtonVariant.PRIMARY} button={true} onClick={this.onSubmit}>
								<Label k="entityForm.submit" v="Submit" />
							</ButtonView>
					</BlockView>
				</DialogView>
			);
	};

	public render() {
		const {
			config: {
				content,
				itemType,
				showThumbnails,
				thumbnailHeight,
				view
			},
			instance
		} = this.props;

		const sType: ItemTypeOptions = iDef(itemType) ? itemType : ItemTypeOptions.DEFAULT;

		const items = (content && content.length > 0) && content.map((item, i) => {

			if (ItemTypeOptions.BUTTON === sType) {
				return (
					<ButtonView onClick={() => window.open(item.link, "_blank")} viewKey="button">
						{item.title}
					</ButtonView>
				);
			}

			return (				
				<a key={i} target="_blank" href={item.link}>
					<CardView interactive={iDef(item.link)} variant={CardVariant.SURFACE} viewKey="card">
						{
							showThumbnails && (
								<ImageView
									style={{
										minHeight: thumbnailHeight || '150px'
									}}
									variant={ImageVariant.THUMBNAIL}
									src={item.iconUrl}
									viewKey="thumbnail"
								/>
							)
						}
						<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="card-primary">
							{
								item.title && (
									<HeadingView viewKey="card.title">{item.title}</HeadingView>
								)
							}
							{item.body ? item.body.replace(/\\n/g, `\n`) : item.body}
						</BlockView>
					</CardView>
				</a>
			);
		});

		if (!items || items.length < 1) {
			return (
				<Labels.QLNoResults/>
			);
		}

		if (items && items.length < 4 && (view === ListTypeOptions.CAROUSEL || view === ListTypeOptions.ROWS)) {
			return (
				<React.Fragment>
				  { this.state.isOpen ? this.showDialog() : null }
				  { TokenSession.hasRoles("ROLE_ADMIN") && (
					<div>
						<ButtonView
							viewKey="edit.button"
							onClick={this.toggleOpen}
							style={{ marginBottom: "15px" }}
						/>
					</div>				
				  )}
				  <RowsView key="rows" viewKey="rows">
					{items}
				  </RowsView>
				</React.Fragment>
			);
		}


		if (view === ListTypeOptions.CAROUSEL) {

			return (
				<React.Fragment>
				  {this.state.isOpen ? this.showDialog() : null}
				  
				  {TokenSession.hasRoles("ROLE_ADMIN") && (
						<ButtonView
							viewKey="edit.button"
							onClick={this.toggleOpen}
							style={{ marginBottom: "15px" }}
						/>		
				  )}
				  <CarouselView
					items={items}
					key="carousel"
					viewKey="carousel"
				  />
				</React.Fragment>
			);
		}

		if (view === ListTypeOptions.ROWS) {

			return (
				<React.Fragment>
				  { this.state.isOpen ? this.showDialog() : null }
				  { TokenSession.hasRoles("ROLE_ADMIN") && (
					<div>
						<ButtonView
							viewKey="edit.button"
							onClick={this.toggleOpen}
							style={{ marginBottom: "15px" }}
						/>
					</div>				
				  )}
				  <RowsView key="rows" viewKey="rows">
					{items}
				  </RowsView>
				</React.Fragment>
			);
		}

		return items;

	}
}



// WEBPACK FOOTER //
// ./src/panels/quickLinks/QuickLinks.panel.tsx